import {type Writable, writable} from 'svelte/store'

export let dark_mode: Writable<boolean> = writable(false)

// export const LFS_PREPEND = writable(0)
